import React, { useEffect } from 'react';
import { Box } from 'edenred-ui';
import { connect, useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import { getFinnishAddresses } from '@epi-selectors/api';
import { EditDeliveryInfoRadio } from '@epi-forms/controls/EditDeliveryInfoRadio';
import { FormFields } from '@epi-forms/helpers';
import { EditDeliveryInfoProps } from '@epi-models/forms/EditDeliveryInfo';

import { DeliveryMethods } from '../../../constants/deliveryMethods';
import '../DeliveryInfo.scss';

function EditDeliveryInfo({ isLoading }: EditDeliveryInfoProps) {
  const addresses = useSelector(getFinnishAddresses);
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    if (
      getValues(FormFields.DeliveryMethod) === DeliveryMethods.ToSavedAddress &&
      !isLoading &&
      addresses &&
      addresses.length === 0
    ) {
      setValue(FormFields.DeliveryMethod, DeliveryMethods.ToOtherAddress);
    }
  });

  return (
    <div className="DeliveryInfo">
      <Box margin="10px 0" p={2}>
        <EditDeliveryInfoRadio />
      </Box>
    </div>
  );
}

const EditDeliveryInfoWithI18n = withTranslation()(connect()(EditDeliveryInfo));

export { EditDeliveryInfoWithI18n as EditDeliveryInfo };
